import styled from '@styled';

interface StyledUlProps {
  padding?: string;
  listPosition?: string;
  margin?: string;
  display?: string;
  borderLeft?: string;
  listStyle?: string;
}

const StyledUl = styled('ul').withConfig({
  shouldForwardProp: (prop) => !['listPosition', 'borderLeft', 'listStyle'].includes(prop),
})<StyledUlProps>`
  padding: ${(props) => props.padding || '15px 0 0'};
  list-style-position: ${(props) => props.listPosition || 'initial'};
  display: ${(props) => props['data-display'] || 'block'};
  border-left: ${(props) => props['data-borderLeft'] || 'none'};
  list-style-type: ${(props) => props.listStyle || 'disc'};

  margin: ${(props) => props['data-margin'] || '0'};
`;

export default StyledUl;
